"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CfgCssClassEditor = /** @class */ (function (_super) {
    __extends(CfgCssClassEditor, _super);
    function CfgCssClassEditor(props) {
        return _super.call(this, props) || this;
    }
    CfgCssClassEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    css_class_name: _item.css_class_name,
                    css_type_code: _item.css_type_code,
                    css_type_title: _item.css_type_title,
                    is_deprecated: _item.is_deprecated,
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(_this.props.lang.editor.breadcrumb.edit_css_class);
                });
            }
        }
        else {
            this.setState({
                css_class_name: "",
                css_type_code: 0,
                css_type_title: "",
                is_deprecated: false,
            }, function () {
                _this.props.state.setExtBreadCrumbPath(_this.props.lang.editor.breadcrumb.new_css_class);
            });
        }
        this.doReSetRules();
    };
    CfgCssClassEditor.prototype.doReSetRules = function () {
        this.setState({
            css_class_name_rules: { isError: false },
            css_type_rules: { isError: false }
        });
    };
    CfgCssClassEditor.prototype.OnUpdateDataClick = function () {
        var _this = this;
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                css_class_name: this.state.css_class_name,
                css_type_code: this.state.css_type_code,
                is_deprecated: this.state.is_deprecated
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.editor.message.css_class_changed);
            });
        }
    };
    CfgCssClassEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.css_class_name) || (this.state.css_class_name.length === 0)) {
            this.setState({
                css_class_name_rules: {
                    isError: true,
                    errorMessage: this.props.lang.editor.error.field_class_name_empty
                }
            });
            return false;
        }
        if ((this.state.css_type_code === 0) || (this.state.css_type_title.length === 0)) {
            this.setState({
                css_type_rules: {
                    isError: true,
                    errorMessage: this.props.lang.editor.error.field_class_type_empty
                }
            });
            return false;
        }
        return true;
    };
    CfgCssClassEditor.prototype.OnNewDataClick = function () {
        var _this = this;
        if (this.isDataValid()) {
            this.props.data.AddData({
                css_class_name: this.state.css_class_name,
                css_type_code: this.state.css_type_code,
                is_deprecated: this.state.is_deprecated
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify(_this.props.lang.editor.message.css_class_added);
            });
        }
    };
    CfgCssClassEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CfgCssClassEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return this.props.lang.editor.title.new_css_class;
        }
        else {
            return this.props.lang.editor.title.edit_css_class;
        }
    };
    CfgCssClassEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 360 },
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: this.props.lang.editor.fields.class_name.caption,
                    placeholder: this.props.lang.editor.fields.class_name.placeholder
                }, value: this.state.css_class_name, onValueChanged: function (newVal) {
                    _this.setState({
                        css_class_name: newVal,
                        css_class_name_rules: { isError: false }
                    });
                }, required: true, rules: this.state.css_class_name_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: {
                    caption: this.props.lang.editor.fields.class_type.caption,
                    placeholder: this.props.lang.editor.fields.class_type.placeholder
                }, value: { key: this.state.css_type_code, value: this.state.css_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        css_type_code: newVal.key,
                        css_type_title: newVal.value,
                        css_type_rules: { isError: false }
                    });
                }, items: this.props.availCssTypes, disabled: this.props.record != null, required: true, rules: this.state.css_type_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: this.props.lang.editor.checkboxes.deprecated, value: this.state.is_deprecated, onChecked: function (checked) {
                    _this.setState({
                        is_deprecated: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: {
                    btnEdit: this.props.lang.editor.buttons.save,
                    btnNew: this.props.lang.editor.buttons.create,
                    btnGoBack: this.props.lang.editor.buttons.back
                }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CfgCssClassEditor;
}(React.Component));
exports.default = CfgCssClassEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_css_class/ui/component/CfgCssClassEditor.tsx
// module id = 2358
// module chunks = 0